import rq from '@/request'

const resource = 'auth'
const recoverPassword = (email, type) => rq.post(`${resource}/recovery`, {email, type})
const check_token = token => rq.get(`${resource}/reset/${token}`)
const reset_password = data => rq.post(`${resource}/reset`, data)
const get_user_info = data => rq.get(`${resource}/user`, data)

export default {
  recoverPassword,
  check_token,
  reset_password,
  get_user_info
}



// WEBPACK FOOTER //
// ./src/api/auth.js